import privateInstance from "../privateClient";
import publicInstance from "../publicClient";
import {
  FetchProfileQueryType,
  FetchUserAccountsQueryType,
  SignInQueryType,
  SignOutQueryType,
} from "./types";

export const userApi = {
  getUserAccounts: async ({ email }: FetchUserAccountsQueryType["Params"]) => {
    try {
      const response = await publicInstance.get<
        FetchUserAccountsQueryType["Data"]
      >(`/auth/user-accounts?email=${email}`);

      return response.data;
    } catch (err) {
      return null;
    }
  },

  signIn: async ({ tenant, username, password }: SignInQueryType["Params"]) => {
    try {
      const response = await privateInstance.post<SignInQueryType["Data"]>(
        "/sign-in",
        {
          username,
          password,
        },
        {
          params: {
            tenant,
          },
        },
      );

      return response.data;
    } catch (err) {
      return null;
    }
  },

  signOut: async () => {
    try {
      await privateInstance.post<SignOutQueryType["Data"]>("/sign-out");

      return true;
    } catch (err) {
      return false;
    }
  },

  getMyProfile: async () => {
    try {
      const response =
        await privateInstance.get<FetchProfileQueryType["Data"]>("/me");

      return response.data;
    } catch (err) {
      return null;
    }
  },
};
